import _ from "lodash"

// takes a Javascript object (with keys, values)
// and splits values bigger than <chunk_size> to chunks
// values are JSON stringified
const chunk = (object, chunk_size) =>
  _.transform(object, (result, value, key) => {
    if (byte_size_of(value) < chunk_size) return (result[key] = value)

    if (typeof value === "object") value = JSON.stringify(value)
    const chunks = value.match(RegExp(`.{1,${chunk_size}}`, "g"))
    return chunks.map((c, i) => (result[`${key}_${i}`] = c))
  })

// taken from https://stackoverflow.com/a/12205668
const byte_size_of = (string) => encodeURI(string).split(/%..|./).length - 1

export default chunk
